export enum HEADER_STATES {
  SIGN_IN,
  SIGN_UP,
  BACK,
  FACETS,
  DASHBOARD,
  LOGO_ONLY
}
